import { useEffect } from 'react';
import { trackEvent } from 'dibs-tracking';

import { Suggestions } from './useSearchSuggestions';
import { SEARCH_BAR_TRACKING } from '../utils/sharedSearchBarConstants';

type useSearchBarTrackingArgs = {
    isVisible: boolean;
    showRecentlyViewed: boolean;
    recentSearches: NonNullable<Suggestions>;
    suggestions: Suggestions;
};
export const useSearchBarTracking = ({
    isVisible,
    showRecentlyViewed,
    recentSearches,
    suggestions,
}: useSearchBarTrackingArgs): void => {
    const hasRecentSearches = recentSearches.length > 0;
    const hasSuggestions =
        !!suggestions && suggestions.some(suggestion => (suggestion?.terms || []).length > 0);

    useEffect(() => {
        // Need to have hasSuggestions here to prevent double tracking on re-render
        if (isVisible && hasRecentSearches && showRecentlyViewed && !hasSuggestions) {
            trackEvent({
                category: SEARCH_BAR_TRACKING.CATEGORIES.NAVIGATION,
                action: SEARCH_BAR_TRACKING.ACTIONS.RECENT_SEARCHES_DISPLAY,
            });
        }
        if (isVisible && !showRecentlyViewed && hasSuggestions) {
            trackEvent({
                category: SEARCH_BAR_TRACKING.CATEGORIES.NAVIGATION,
                action: SEARCH_BAR_TRACKING.ACTIONS.SEARCH_SUGGESTIONS_DISPLAY,
            });
        }
    }, [isVisible, hasRecentSearches, showRecentlyViewed, hasSuggestions]);
};
